// src/pages/AdminLogin.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography, Stack } from '@mui/material';
import { API_BASE } from '../utils/api';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || 'Login failed');
      localStorage.setItem('adm_t', data.token);
      navigate('/admin', { replace: true });
    } catch (e) {
      setErr(e.message || 'Login failed');
    }
  }

  return (
    <Box sx={{ maxWidth: 420, mx: 'auto', px: 2, py: 6 }}>
      <Typography variant="h4" mb={2}>Admin Login</Typography>
      <form onSubmit={onSubmit}>
        <Stack spacing={2}>
          <TextField label="Email" value={email} onChange={e=>setEmail(e.target.value)} />
          <TextField label="Password" type="password" value={password} onChange={e=>setPassword(e.target.value)} />
          {err && <Typography color="error">{err}</Typography>}
          <Button type="submit" variant="contained">Sign In</Button>
        </Stack>
      </form>
    </Box>
  );
}